import { FadeTransition } from 'vue2-transitions';
import { nanoid } from 'nanoid';
import emitter from '../../utils/mixins/emitter.js';
import EyeIcon from '../../assets/icons/16/Eye_16.vue.js';
import EyeCloseIcon from '../../assets/icons/16/Eye_close_16.vue.js';

//
var script = {
  name: 'FormItem',
  components: {
    FadeTransition: FadeTransition,
    EyeIcon: EyeIcon,
    EyeCloseIcon: EyeCloseIcon
  },

  provide: function provide() {
    return {
      formItem: this
    };
  },

  mixins: [emitter],
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    textAfter: {
      type: String,
      default: ''
    },
    textBefore: {
      type: String,
      default: ''
    },
    textError: {
      type: String,
      default: ''
    },
    isBoldLabel: {
      type: Boolean,
      default: false
    },
    isGrayLabel: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function (vm) { return ({
    nativeId: vm.id,
    passwordVisible: false
  }); },
  computed: {
    rootClass: function rootClass() {
      return {
        '_success': this.isValid && !this.textError.length,
        '_error': !!this.textError,
        '_bold-label': this.isBoldLabel,
        '_gray-label': this.isGrayLabel,
        '_password': this.showPassword
      };
    },

    beforeTextHelper: function beforeTextHelper() {
      return this.textError ? this.textError : this.textBefore;
    },

    passwordHelpText: function passwordHelpText() {
      return this.passwordVisible ? 'Скрыть пароль' : 'Показать пароль';
    }

  },

  mounted: function mounted() {
    if (!this.id) {
      this.nativeId = nanoid();
    }

    this.updatePadding();
  },

  updated: function updated() {
    this.updatePadding();
  },

  methods: {
    updatePadding: function updatePadding() {
      if (this.$refs.beforeText) {
        var el = this.$refs.beforeText;
        var height = el.offsetHeight;
        var defaultHeight = 24;

        if (height > defaultHeight && this.$refs.container) {
          this.$refs.container.style.paddingBottom = (height - defaultHeight) + "px";
        } else {
          this.$refs.container.style.paddingBottom = '';
        }
      } else {
        this.$refs.container.style.paddingBottom = '';
      }
    },

    handlePasswordVisible: function handlePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
      this.broadcast('InputControl', 'focusInputAfterShowPassword');
    }

  }
};

export default script;
